define('views/blocks/CartMinimumShippingPriceView',['underscore','backbone','app','SubView','template!blocks/cart/minimum-shipping-price'],
    function (_,Backbone,app,SubView,minimumShippingTemplate) {

        //
        // Minimum delivery shipping Cart View
        //

        return Backbone.View.extend(SubView).extend({

            initialize: function () {
                var view = this,
                    cart = app.getCart();
                view.listenTo(cart, 'changeContext', view.render);
                view.listenTo(cart, 'empty', view.updateActive);
                view.listenTo(cart.getProducts(), 'add update remove', view.updateActive);
                view.updateActive();
            },
            render: function () {
                var view = this;
                view.$el.html(minimumShippingTemplate({cart:app.getCart()}));
                view.updateActive();
            },
            updateActive:function(){
                this.$el.toggleClass('active',!app.getCart().hasMinimumPrice());
            }

        });
    });
